export enum ContactRepType {
	Contact = 1,
	FieldRep = 2,
	RabbiCoordinator = 3,
	AccountRep = 4,
	KCSigner = 5,
	AgencyUser = 6,
}
